// Emitted in place of a GitHub result when the org has no usable GitHub
// integration for this project. `auth_broken` means the App was deleted, its
// key revoked, or the installation removed. A connection still waiting on its
// webhook secret is not one of these: its credential works, so the tools run and
// the gap is reported on the integrations page instead.
export interface GitHubSetupRequiredPayload {
  type: "github_setup_required";
  reason: "account_not_configured" | "not_exposed" | "auth_broken";
}

const REASONS: ReadonlySet<GitHubSetupRequiredPayload["reason"]> = new Set([
  "account_not_configured",
  "not_exposed",
  "auth_broken",
]);

const isReason = (v: unknown): v is GitHubSetupRequiredPayload["reason"] =>
  typeof v === "string" && REASONS.has(v as GitHubSetupRequiredPayload["reason"]);

// Tolerates unknown reasons so a newer backend still renders the card.
export const parseGitHubSetupRequiredPayload = (v: unknown): GitHubSetupRequiredPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "github_setup_required") return null;
  return {
    type: "github_setup_required",
    reason: isReason(r.reason) ? r.reason : "account_not_configured",
  };
};
